<!-- src/components/Loading.vue -->
<template>
  <div v-if="visible" class="loading-overlay">
    <div class="loading-balls">
      <div class="ball"></div>
      <div class="ball"></div>
      <div class="ball"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {
      visible: false
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /*background: rgba(0, 0, 0, 0.1);*/
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-balls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 60px;
}

.ball {
  width: 15px;
  height: 15px;
  background-color: #2f4050;
  border-radius: 50%;
  animation: bounce 0.3s infinite alternate;
}

.ball:nth-child(2) {
  animation-delay: 0.2s;
}

.ball:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  to {
    transform: translateY(-20px);
  }
}
</style>
